import { useState, useRef, useEffect } from "react";
import Icon from "@mdi/react";
import { mdiChevronDown, mdiClose, mdiCheck } from "@mdi/js";
import "./CatalogueSelect.scss";

const CatalogueSelect = ({ value, onChange, placeholder, options = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange(null);
  };

  return (
    <div
      ref={selectRef}
      className={`catalogue-select ${isOpen ? "open" : ""} ${value !== null ? "has-value" : ""}`}
    >
      <div
        className="catalogue-select__trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="catalogue-select__label">
          {value !== null ? value : placeholder}
        </span>
        <div className="catalogue-select__icons">
          {value !== null && (
            <button
              className="catalogue-select__clear"
              onClick={handleClear}
              type="button"
            >
              <Icon path={mdiClose} size={0.7} />
            </button>
          )}
          <Icon
            path={mdiChevronDown}
            size={0.8}
            className={`catalogue-select__chevron ${isOpen ? "rotated" : ""}`}
          />
        </div>
      </div>

      {isOpen && (
        <div className="catalogue-select__dropdown">
          {options.length > 0 ? (
            options.map((option, index) => (
              <div
                key={index}
                className={`catalogue-select__option ${value === option ? "selected" : ""}`}
                onClick={() => handleSelect(option)}
              >
                <span>{option}</span>
                {value === option && (
                  <Icon path={mdiCheck} size={0.7} className="catalogue-select__check" />
                )}
              </div>
            ))
          ) : (
            <div className="catalogue-select__empty">No options available</div>
          )}
        </div>
      )}
    </div>
  );
};

export default CatalogueSelect;

